import { Link } from "@tanstack/react-router"
import classNames from "classnames"
import {
  Logo,
  PublicPageCountryOfResidenceSelect,
  OverlayLoader,
} from "src/components"
import {
  useCountrySelectionContext,
  usePolyglot,
} from "src/contexts"
import { useCountries } from "src/hooks"
import styles from "src/pages/IndexPage/IndexPage.module.scss"

const polyglotPrefix = "pages.index."

export function OauthAuthorizeIndexPage() {
  const { isLoading } = useCountries()
  const polyglot = usePolyglot()
  const {
    country,
    confirmCountrySelection,
  } = useCountrySelectionContext()

  return (
    <div className={styles.container}>
      <OverlayLoader visible={isLoading} />
      <div className={styles.logoContainer}>
        <Logo className={styles.logo} />
        <PublicPageCountryOfResidenceSelect />
      </div>
      <div
        className={classNames(
          styles.linkContainer,
          !country && styles.linkContainerHidden,
        )}
      >
        <Link
          to="/oauth/authorize/sign_in"
          className={styles.link}
          id="sign-in-button"
          onClick={confirmCountrySelection}
        >
          {polyglot.t(`${polyglotPrefix}sign_in_link`)}
        </Link>
        <Link
          to="/oauth/authorize/sign_up"
          className={styles.link}
          id="sign-up-button"
          onClick={confirmCountrySelection}
        >
          {polyglot.t(`${polyglotPrefix}sign_up_link`)}
        </Link>
      </div>
    </div>
  )
}
